import React from 'react';
import ServicePageLayout from './service/ServicePageLayout';
import time2callPageData from '../data/servicePages/time2call';

const Time2CallPage = () => <ServicePageLayout data={time2callPageData} />;

export default Time2CallPage;
